import { FaFilePdf } from "react-icons/fa";
import { FiMail } from "react-icons/fi"; // Email icon
import "./Footer.css"; // Optional styling file

const Footer = () => {
  return (
    <footer
      className="footer-container"
      style={{
        background: "rgb(45 116 121)",
        padding: "32px 20px 0px 20px",
        width: "100%",
        margin: "0px auto",
        color: "#F5F7FA",
        fontSize: "16px",
      }}
    >
      <div
        className="footer-content"
        style={{
          display: "flex",
          justifyContent: "space-between",
          flexWrap: "wrap",
          margin: "0 auto",
          gap: "20px",
          width: "76%",
        }}
      >
        {/* Office Address */}
        <div
          className="office_address_div"
          style={{
            flex: "1",
            minWidth: "220px",
            marginBottom: "20px",
            padding: "0 10px",
            fontSize: "16px",
          }}
        >
          <h3
            style={{
              color: "#F5F7FA",
              marginBottom: "10px",
              fontSize: "20px",
                    fontWeight:"bold",
            }}
          >
            Office Address
          </h3>
          <p style={{ lineHeight: "1.5" }}>Plot No.45 to 48</p>
          <p style={{ lineHeight: "1.5" }}>Road No.09,</p>
          <p style={{ lineHeight: "1.5" }}>IDA Nacharam</p>
          <p style={{ lineHeight: "1.5" }}>Hyderabad – 500076</p>
        </div>

        {/* Contact Us */}
        <div
          className="office_address_div"
          style={{
            flex: "1",
            minWidth: "220px",
            marginBottom: "20px",
            padding: "0 10px",
           
          }}
        >
          <h3
            style={{
              color: "#F5F7FA",
              marginBottom: "10px",
              fontSize: "20px",
              fontWeight:"bold",
            }}
          >
            Contact Us
          </h3>
          <p style={{ lineHeight: "1.5" }}>
            <strong>Phone:</strong> 9063488659
          </p>
          <p style={{ lineHeight: "1.5" }}>
            <strong>Email:</strong>{" "}
            <a
              href="mailto:bd@varanouslabs.com"
              style={{ color: "#F5F7FA", textDecoration: "none" }}
            >
              bd@varanouslabs.com
            </a>
          </p>
          <p style={{ lineHeight: "1.5" }}>
            <strong>WhatsApp No:</strong>{" "}
           <a
  href="https://wa.me/9063488659?text=Hi%20Varanous%20Labs%20team,%20I%20would%20like%20to%20know%20more%20about%20your%20services."
  target="_blank"
  rel="noopener noreferrer"
  style={{ color: "#F5F7FA", textDecoration: "none" }}
>
  9063488659
</a>

          </p>
        </div>

        {/* Reach Us (Clickable Google Map) */}
        <div style={{ flex: "1", minWidth: "250px" ,      fontWeight:"bold",}}>
          <h3 style={{ marginBottom: "10px", fontSize: "20px" }}>Reach Us</h3>
          <a
            href="https://maps.app.goo.gl/HjQJ3vKeQ3QWMWjR7"
            target="_blank"
            rel="noopener noreferrer"
            title="Click to open Varanous Labs in Google Maps with pin"
            style={{ display: "block", width: "100%" }}
          >
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3806.374750681293!2d78.56319741487383!3d17.44432508804014!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcb99f99168fd5d%3A0x83708c7d3cd318e6!2sVaranous%20Labs%20Private%20Limited!5e0!3m2!1sen!2sin!4v1717584799162!5m2!1sen!2sin"
              width="100%"
              height="200"
              style={{
                border: 0,
                borderRadius: "6px",
                cursor: "pointer",
                pointerEvents: "none",
              }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Varanous Labs Location"
            ></iframe>
          </a>
        </div>
      </div>

      {/* CopyRight */}
      <div
        style={{
          textAlign: "center",
          padding: "15px 10px 10px",
          borderTop: "1px solid rgba(255, 255, 255, 0.3)",
          marginTop: "10px",
          fontSize: "14px",
        }}
      >
        <a
          href="https://moksha-technologies.com/"
          target="_blank"
          rel="noopener noreferrer"
          style={{ color: "#F5F7FA", textDecoration: "none" }}
        >
          <span>Copy Rights © 2025 Varanous Labs</span> |{" "}
          <span title="Visit MS Technologies">Powered By MS Technologies</span>.
        </a>
      </div>
    </footer>
  );
};

export default Footer;
